import ApiService from './api.service';

class RequestLinkTypeService {
  static async getRequestLinkTypes() {
    const url = `${window.ambulnzConfig.tenantedRestApiUrl}/RequestLinkTypes`;
    const response = await ApiService.get(url);
    return response.json();
  }
}

export default RequestLinkTypeService;
